import { createElement } from "react";

import { TeamOutlined } from "@ant-design/icons";

import type { TopBarNavModule } from "@neu/libui";

export const pbmPortalTopNavModules: TopBarNavModule[] = [
	{
		name: "Patients",
		path: "/pbm-portal/patient",
		icon: createElement(TeamOutlined),
	},
];
